import { render } from "./ValueYourTrade.vue?vue&type=template&id=35472f5c&lang=true"
import script from "./ValueYourTrade.vue?vue&type=script&lang=js"
export * from "./ValueYourTrade.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__